import React from 'react';
import { useParams } from 'react-router-dom';
import { Modal } from '../modals/v2/helpers/v2.modal.helpers';
import { AgencyUploadDocumentModalConfig } from './AgencyUploadDocumentModal';
import { UPLOAD_MAX_FILE_SIZE, UPLOAD_MAX_FILE_SIZE_MESSAGE } from '.';
import useGetPrimeXQuoteDetails from '../../console/workflows/quotes/prime-x/hooks/useGetPrimeXQuoteDetails';
import type { PrimeXProductType, ProductType } from '../../types';
import useNotifications from '../../_lib/notifications/useNotifications';

export const withUploadFeatureDocuments = (minHeight: any, from: any) => {
  return (Component: any) => {
    return (props: any) => {
      const params = useParams<{
        quoteId: string;
        product: ProductType & PrimeXProductType;
      }>();

      const quote = useGetPrimeXQuoteDetails({
        id: params.quoteId,
        product: params.product,
      });

      const treatyId = quote.data?.quote?.treatyId ?? '';

      const { docsData = { companyName: '' } } = props;
      const notifications = useNotifications();
      const truncatedAccountName =
        docsData?.companyName?.length > 32
          ? `${docsData?.companyName?.substr(0, 32)}...`
          : docsData?.companyName;

      const modalTitle = React.useMemo(() => {
        return docsData?.companyName
          ? `Upload file for ${truncatedAccountName}`
          : 'Upload File';
      }, [docsData.companyName, truncatedAccountName]);

      const onDrop = React.useCallback(
        (files: any) => {
          const wrapper = (message: any, severity: any) => {
            notifications.show({
              type: severity?.variant === 'default' ? 'info' : severity?.variant,
              title: message,
            });
          };

          if ((files?.[0]?.size ?? 0) > UPLOAD_MAX_FILE_SIZE) {
            wrapper(UPLOAD_MAX_FILE_SIZE_MESSAGE, {
              variant: 'error',
            });
          } else {
            Modal.show(AgencyUploadDocumentModalConfig, {
              data: { file: files[0], docsData, from, treatyId },
              config: {
                title: modalTitle,
                maxWidth: 'sm',
              },
            });
          }
        },
        // eslint-disable-next-line
        [docsData]
      );

      return (
        // @ts-expect-error TS(2322): Type '{ children: Element; name: string; }' is not... Remove this comment to see the full error message
        <section name="withUploadFeatureDocuments">
          <Component {...props} onDrop={onDrop} minHeight={minHeight} />
        </section>
      );
    };
  };
};
